import React, { useEffect, useState } from "react";

// third-party
import { FormattedMessage } from "react-intl";

// assets
import {
  IconUserCheck,
  IconBasket,
  IconMessages,
  IconMail,
  IconCalendar,
  IconNfc,
  IconBuildingStore,
  IconTrendingUp
} from "@tabler/icons";
import { getDecryptDataFromLocal } from "../../utils/encrypt";
import { canAccessShopifyOrders } from "./shopifyOrderAccess";
import bulkDeliveryCenterPendingCount from "../../Services/bulkDeliveryCenterPendingCount";

// Red notification badge showing unread Delivery Center chat count for the
// logged-in user (agent: own orders, TL/FM/manager: team orders, admin: all).
// Shown on both the "Bulk Analysis" group and the "Delivery Center Orders"
// item so it's visible whether or not the submenu is expanded.
const DeliveryCenterPendingBadge = () => {
  const [n, setN] = useState(bulkDeliveryCenterPendingCount.current);
  useEffect(() => bulkDeliveryCenterPendingCount.subscribe(setN), []);
  if (!n || n <= 0) return null;
  return (
    <span style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      minWidth: 20,
      height: 20,
      padding: "0 6px",
      marginLeft: 8,
      borderRadius: 10,
      background: "#d32f2f",
      color: "#fff",
      fontSize: 11,
      fontWeight: 800,
      lineHeight: 1,
    }}>{n > 99 ? "99+" : n}</span>
  );
};

const withDeliveryCenterBadge = (id) => (
  <span style={{ display: "inline-flex", alignItems: "center" }}>
    <FormattedMessage id={id} />
    <DeliveryCenterPendingBadge />
  </span>
);

// constant
const icons = {
  IconUserCheck: IconUserCheck,
  IconBasket: IconBasket,
  IconMessages: IconMessages,
  IconMail: IconMail,
  IconCalendar: IconCalendar,
  IconNfc: IconNfc,
  IconBuildingStore: IconBuildingStore,
  IconTrendingUp: IconTrendingUp
};

const bulkAccess = ['7001029850', '9315481432', '9719836187', '9667530528', '9891774071', '8374454823', '8178277221', '9268096291', '8826956978', '8126040893', '8279461474', '8750022180', '9873804039', '7982526137', '8750751510', '9811068834', '7503080335', '9599412543', '8969708515', '9693813591', '7052950504', '8076096127', '8294360196', '9560087843', '8825120748', '9870351257', '9911960633', '8130902064', '7838688729']
const updatedBulkAccess = [...new Set([...bulkAccess, '9911960633', '9643408732', '7838688729', '9034223172', '8800970879', '8826193896', '9315405080', '8448300516', '9319132363', '9990359945', '7701974309', '8383908752', '7532035127', '9315362571', '9873380793', '8700175494', '9560128741', '9716226377', '7417448633', '9625389383', '7048952168', '9310278575'
])];
const agentRole = getDecryptDataFromLocal("setRole");
const agentType = localStorage.getItem("agentType");

const bulkOrderCreate = [...bulkAccess, '9911579990', '9315405080', '8448300516', '9319132363', '9990359945', '9643408732', '9990359945', '9911579990', '7982526137', '7838688729', '9034223172', '8800970879', '9625389383']
const cashBulkOrderCreate = [...bulkAccess, '9911579990', '9315405080', '8448300516', '9319132363', '9990359945', '9911579990', '8800970879', '9625389383'].filter((item) => item !== '8178277221', '7982526137')
const bulkOrderApproval = [...bulkAccess,'9990619120', '9911579990', '9315405080', '8800970879', '8826193896', '7701974309', '8383908752', '8448300516', '7532035127', '9319132363', '9643408732', '9990359945', '9911579990', '7982526137', '9315362571', '9034223172', '7838688729', '9911960633', '7838688729', '9625389383']
const bulkOrderList = [...bulkAccess, '9873380793','9990619120', '8700175494', '8800970879', '8826193896', '8448300516', '9560128741', '7532035127', '9319132363', '9716226377', '9034223172', '7838688729', '9911960633', '7838688729', '9625389383']
const bulkShipOrder = [...bulkAccess, '9873380793','9990619120', '8700175494', '9911579990', '9315405080', '8800970879', '8826193896', '7701974309', '8383908752', '8448300516', '9560128741', '7532035127', '9319132363', '9911579990', '7982526137', '7417448633', '9716226377', '9034223172', '9625389383']

const allBulkAnalysis = ['9315481432','9990619120', '9667530528', '8178277221', '8374454823', '9719836187', '8126040893', '8750022180', '7982526137', '8750751510', '9811068834', '7503080335', '9599412543',"8130902064", '7982526137', '9693813591', '7052950504', '8969708515', '9873380793', '9560087843', '8810613343', '8825120748', '9870351257', '9911960633', '8800970879']
const BulkAnalysis = [...allBulkAnalysis, '9560128741', '8448300516', '9319132363', '8279461474', '8076096127', '8700175494', '7011976531', '9891774071', '7838688729', '9873804039', '9911960633', '9034223172', '9911095513', '8851162831', '9911579990']
const bulkOrderMargin = [...allBulkAnalysis,]
const updateZohoCustomerId = [...allBulkAnalysis, '9599412543','8130902064']
const bulkproducteancodereplacement = ['9719836187', '8178277221']
const bulkOrderAgentUpdate = ['9719836187', '8178277221', '8285882010']
const moveOrderBulkToProduct = ['7048952168', '9719836187', '9315481432']
const addChildSellerAccess = ['9719836187', '9891774071', '9599412543','8130902064', '9625389383']
const moveOrderStage1 = ['8178277221', '9719836187', '9693813591', '9034223172', '9315481432']
const orderConfirmationPanelAccess = ['9315481432']
const pincodeServiceabilityAccess = ['9719836187', '9811068834', '9891774071', '9625389383']
const websiteOrderAccess = ['9354530453', '9625389383', '9315481432', '7048952168', '9310278575', '8287195473']




//-----------------------|| Customer MENU ITEMS ||-----------------------//

const phoneNumber = getDecryptDataFromLocal("phoneNumber");
const reportAllowedTypes = [1, 2, 3, 4, 17];
const reportAllowedPhone = '9873804039';
// Bulk Order Download / Bulk Product Download: each user only gets their own
// scoped data on the backend (agent -> self, TL/FM -> own team, Ameen -> all
// retail, Manjay -> bulk team only), so the tab is now opened up to those
// roles too instead of just admins/Ameen. Existing reportAllowedTypes/phone
// check kept as-is, just OR'd with the new roles.
let isBulkWaManager = false;
try { isBulkWaManager = localStorage.getItem("bulkWaManager") === "true"; } catch (e) { /* ignore */ }
const canAccessBulkReports = reportAllowedTypes.includes(Number(agentType)) || reportAllowedTypes.includes(Number(agentRole)) || agentType == reportAllowedPhone || phoneNumber == reportAllowedPhone
  || [5, 13, 14].includes(Number(agentRole)) || isBulkWaManager;
export const Bulk = {
  id: "Bulk",
  title: <FormattedMessage id="Bulk" />,
  type: "group",
  children: [
    // canAccessShopifyOrders(): an admin outside updatedBulkAccess must still
    // get the "Bulk Order" group so the Shopify Orders item has somewhere to
    // live — every other child below keeps its own gate.
    ((updatedBulkAccess.includes(phoneNumber) || agentRole == 14) || agentRole == 5 || canAccessShopifyOrders()) &&
    {
      id: "Bulk Order",
      title: <FormattedMessage id="Bulk Order" />,
      type: "collapse",
      icon: icons["IconBuildingStore"],
      children: [

        (bulkOrderCreate.includes(phoneNumber)) &&
        {
          id: "Bulk Order Create",
          title: <FormattedMessage id="Bulk Order Create" />,
          type: "item",
          url: "/bulk/ordercreate",
        },

        (cashBulkOrderCreate.includes(phoneNumber)) &&
        {
          id: "Cash Bulk Order Create",
          title: <FormattedMessage id="Cash Bulk Order Create" />,
          type: "item",
          url: "/bulk/cashordercreate",
        },

        (addChildSellerAccess.includes(phoneNumber)) &&
        {
          id: "Add Child Seller",
          title: <FormattedMessage id="Add Child Seller" />,
          type: "item",
          url: "/bulk/addbulkparent",
        },
        (bulkOrderApproval.includes(phoneNumber) || agentRole == 5) && {
          id: "Bulk Order Approval by SCM",
          title: <FormattedMessage id="Bulk Order Approval" />,
          type: "item",
          url: "/bulk/bulkorderapprovalforscm",
        },
        (bulkOrderList.includes(phoneNumber)) && {
          id: "Bulk Order List",
          title: <FormattedMessage id="Bulk Order List" />,
          type: "item",
          url: "/bulk/bulkorderlist",
        },
        // Restricted to an explicit allowlist + admins only — was previously
        // bulkOrderList allowlist + every userType-5 agent, scoped down
        // 2026-08-14 since the chat panel here shows any customer's WA
        // thread with no team/agent restriction. Neera (9354530453) was the
        // original grant; 9625389383 added 2026-08-17 (Shailendra, full Bulk
        // Order section access); 9315481432/7048952168/9310278575 added
        // same day (Shailendra, explicit ask). 8796573252 (Nitesh Kumar)
        // added 2026-08-18 after he took over as the website-order-lead
        // agent, then removed 2026-08-29 and replaced with 8287195473
        // (Nazni) when Shailendra moved the role to her (see
        // whatsappInbox.js's syncWebsiteOrderLeadsToAgent).
        (websiteOrderAccess.includes(phoneNumber) || agentRole == 1) && {
          id: "Website Order",
          title: <FormattedMessage id="Website Order" />,
          type: "item",
          url: "/bulk/website-order-list",
        },
        // clensta.com (Shopify) website orders — ship via ShipShopy, AWB back to
        // Unicommerce. Admins + an explicit allowlist ONLY (see
        // shopifyOrderAccess.js; the backend enforces the same list).
        canAccessShopifyOrders() && {
          id: "Shopify Orders",
          title: <FormattedMessage id="Shopify Orders" />,
          type: "item",
          url: "/bulk/shopify-order-list",
        },
        (bulkShipOrder.includes(phoneNumber) || agentRole == 5) && {
          id: "Bulk Ship Status",
          title: <FormattedMessage id="Bulk Ship Order" />,
          type: "item",
          url: "/bulk/bulkshipstatus",
        },

        (pincodeServiceabilityAccess.includes(phoneNumber)) && {
          id: "Pincode Serviceability",
          title: <FormattedMessage id="Pincode Serviceability" />,
          type: "item",
          url: "/bulk/pincode-serviceability",
        },

        // bulkAccess.includes(phoneNumber) &&  {
        //   id: "Move Bulk Order",
        //   title: <FormattedMessage id="Move Bulk Order" />,
        //   type: "item",
        //   url: "/bulk/moveBulkOrder",
        // },
      ],

    },
    (BulkAnalysis.includes(phoneNumber) || agentRole == '14' || canAccessBulkReports) && {
      id: "Bulk Order",
      title: withDeliveryCenterBadge("Bulk Analysis"),
      type: "collapse",
      icon: icons["IconTrendingUp"],
      children: [
        (bulkOrderMargin.includes(phoneNumber)) && {
          id: "Bulk Order Margin",
          title: <FormattedMessage id="Upload Margin" />,
          type: "item",
          url: "/bulk/uploadbulkmargin",
        },
        (canAccessBulkReports) && {
          id: "Bulk Order Download",
          title: <FormattedMessage id="Bulk Order Download" />,
          type: "item",
          url: "/bulk/bulkorderdownload",
        },
        (canAccessBulkReports) && {
          id: "Bulk Product Download",
          title: <FormattedMessage id="Bulk Product Download" />,
          type: "item",
          url: "/bulk/bulkproductdownload",
        },
        (updateZohoCustomerId.includes(phoneNumber)) && {
          id: "Update Zoho Customer Id",
          title: <FormattedMessage id="Update Zoho Customer Id" />,
          type: "item",
          url: "/bulk/updatezohocustomerid",
        },
        (moveOrderBulkToProduct.includes(phoneNumber)) && {
          id: "Order Move Bulk To Product Collection",
          title: <FormattedMessage id="Order Move From Bulk To Product Collection" />,
          type: "item",
          url: "/bulk/ordermovebulktoproduct",
        },
        (moveOrderStage1.includes(phoneNumber)) && {
          id: "Move Order Stage",
          title: <FormattedMessage id="Move Order Stage" />,
          type: "item",
          url: "/bulk/moveorderstage",
        },
        (bulkproducteancodereplacement.includes(phoneNumber)) && {
          id: "Product EAN Code Replace",
          title: <FormattedMessage id="Product EAN Code Replace" />,
          type: "item",
          url: "/bulk/bulk-product-ean-replacement",
        },
        (bulkOrderAgentUpdate.includes(phoneNumber)) && {
          id: "Bulk Order Agent Update",
          title: <FormattedMessage id="Bulk Order Agent Update" />,
          type: "item",
          url: "/bulk/bulk-order-agent-update",
        },
        (orderConfirmationPanelAccess.includes(phoneNumber)) && {
          id: "Order Confirmation Panel",
          title: <FormattedMessage id="Order Confirmation Panel" />,
          type: "item",
          url: "/bulk/orderconfirmationpanel",
        },
        {
          id: "Delivery Center Orders",
          title: withDeliveryCenterBadge("Delivery Center Orders"),
          type: "item",
          url: "/bulk/delivery-center-orders",
        },

      ]
    }
  ],
};
